// extracted by mini-css-extract-plugin
export default {"number":"Number_number__NNSzg","reverse":"Number_reverse__09Cc8"};